export const FollowUpStatus = Object.freeze({
    NO_FOLLOWUP: 'no_followup',
    VALIDATED: 'validated'
});
